<template>
  <v-toolbar
    color="#F4FFBA"
    app
    fixed
    flat
    :extended="$store.state.hasMultitenant"
    extension-height="25px"
    class="px-4 pt-4"
  >
    <v-layout
      class="toolbar"
    >
      <v-flex>
        <div
          @click="$router.push('/')"
        >
          <v-img
            :src="require(`../assets/crmlogo.svg`)"
            contain
            max-width="150px"
            min-width="150px"
          />
        </div>
      </v-flex>
      <v-flex class="positionActions">
        <v-layout class="positionActionsColumns mr-3">
          <v-flex class="d-flex">
            <button
              v-if="updateExists"
              icon
              @click="refreshApp"
            >
              <v-icon>refresh</v-icon>
            </button>
            <span>
              <v-menu
                id="menuConfig"
                v-model="showMenu"
                offset-y
                transition="slide-y-transition"
              >
                <template #activator="{ on }">
                  <div v-on="on" />
                </template>

                <v-list dense>
                  <!-- <div
                    v-if="$store.getters.isManager || $store.getters.isDirector"
                  > -->
                  <!-- <v-subheader>GERENCIAL</v-subheader> -->
                  <!-- <v-list-tile
                      to="/gestaocontatos"
                      @click="countGesContato"
                    >
                      <v-list-tile-action class="ml-3">
                        <v-icon
                          color="black"
                          small
                        >fas fa-users-cog</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <h4>Gerenciar Contatos</h4>
                      </v-list-tile-content>
                    </v-list-tile>
                  </div> -->
                  <!-- <v-subheader>PERFIL</v-subheader> -->
                  <v-list-tile
                    v-if="$store.state.hasMultitenant"
                    to="/login/vendedor"
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        color="primary"
                        small
                      >$vuetify.icons.arrowSwapIcon</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Trocar Loja/Usuário</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile to="/cadastro/editar">
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        small
                        color="primary"
                      >
                        $vuetify.icons.userIcon
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Editar Dados Pessoais</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                  <div>
                    <!-- <v-list-tile
                      @click="
                        openPage('https://sejazipper.zendesk.com/hc/pt-br')
                      "
                    >
                      <v-list-tile-action class="ml-3">
                        <v-icon color="black" small
                          >fas fa-question-circle</v-icon
                        >
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <h4>Central de Ajuda</h4>
                      </v-list-tile-content>
                    </v-list-tile> -->
                    <!-- <v-list-tile
                      @click="
                        openPage(
                          'https://sejazipper.zendesk.com/hc/pt-br/requests'
                        )
                      "
                    >
                      <v-list-tile-action class="ml-3">
                        <v-icon color="black" small>fas fa-headset</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <h4>Meus Chamados</h4>
                      </v-list-tile-content>
                    </v-list-tile> -->
                  </div>
                  <v-list-tile
                    @click="redirectToWhatsapp"
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        color="primary"
                        style="font-size: 20px"
                      >
                        mdi-whatsapp
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Precisa de ajuda?</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="countLogout">
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        color="primary"
                        small
                      >$vuetify.icons.signOutIcon</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Sair</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                    v-if="customer.id === '625096c979564173179b0f98'"
                    @click="$router.push('/pedidos')"
                  >
                    <v-list-tile-action class="ml-3">
                      <v-icon
                        color="primary"
                        medium
                      >
                        $vuetify.icons.basketIcon
                      </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <h4>Pedidos Rock In Rio</h4>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </span>

            <v-flex
              v-if="$store.state.hasMultitenant"
              shrink
            >
              <v-badge
                overlap
                bottom
                class="d-inline"
              >
                <v-avatar
                  v-if="$auth.user.secondPicture"
                  slot="badge"
                  size="18px"
                >
                  <v-img :src="$auth.user.secondPicture" />
                </v-avatar>

                <v-btn
                  flat
                  icon
                  @click.stop="showMenu = true"
                  @click="countProfile"
                >
                  <v-avatar size="32px">
                    <v-img :src="$auth.user.picture" />
                  </v-avatar>
                </v-btn>
              </v-badge>
            </v-flex>

            <v-flex
              v-if="!$store.state.hasMultitenant"
              shrink
            >
              <v-btn
                flat
                icon
                @click.stop="showMenu = true"
                @click="countProfile"
              >
                <v-avatar size="32px">
                  <v-img :src="$auth.user.picture" />
                </v-avatar>
              </v-btn>
            </v-flex>
          </v-flex>
          <v-flex>
            <h6
              class="px-0 grey--text text-xs-right"
              style="
                font-weight: normal;
                font-size: 6px;
                margin-top: 2px;
              "
            >
              Versão: {{ $store.getters.appVersion }}
            </h6>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <template
      v-if="$store.state.hasMultitenant"
      #extension
    >
      <h5 class="profile-txt">
        {{ $store.state.store.name }} -
        {{ $store.state.profile.name }}
      </h5>
    </template>
  </v-toolbar>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { APIService } from '@/resources/campanha.js';
import auth from '@/auth.js';

const api = new APIService();
export default {
  props: {
    source: String,
  },

  data() {
    return {
      counterAddLead: 0,
      counterBuscarContato: 0,
      buscarContatoMarca: false,
      counterGestContato: 0,
      counterLogout: 0,
      counterProfile: 0,
      showMenu: false,
      customer: {},
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },

  computed: {
    ...mapState(['agendaMarca']),
  },

  mounted() {
    this.getCustomer();
  },

  created() {
    /* document.addEventListener(
      'swUpdated', this.showRefreshUI, { once: true }
    );
    navigator.serviceWorker.addEventListener(
      'controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      }
    ); */
  },

  methods: {

    redirectToWhatsapp() {
      const text = encodeURI('Olá! Preciso de ajuda.');

      window.open(`https://wa.me/+5511910751953?text=${text}`, '_blank');
    },

    openPage(title) {
      window.open(title);
    },

    downloadOnboarding() {
      axios({
        url:
          'https://konselior.s3.amazonaws.com/onboard/Onboarding+Kontalk.pdf',
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Manual Kontalk.pdf'); // or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },

    countAddLead() {
      this.counterAddLead += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Adicionar Lead',
        eventValue: this.counterAddLead,
      });
    },

    countGesContato() {
      this.counterGestContato += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Gestao Contatos',
        eventValue: this.counterGestContato,
      });
    },

    countBuscarContato() {
      this.counterBuscarContato += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Buscar Contatos na Marca',
        eventValue: this.counterBuscarContato,
      });
      this.buscarContatoMarca = true;
    },

    countLogout() {
      this.$store.commit('SET_STORE', null);
      this.counterLogout += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Logout',
        eventValue: this.counterLogout,
      });
      this.$auth.logout();
    },

    countProfile() {
      this.counterProfile += 1;
      this.$ga.event({
        eventCategory: 'Header',
        eventAction: 'Exibir Perfil',
        eventValue: this.counterProfile,
      });
    },

    sendMessage() {
      location.href = 'http://api.whatsapp.com/send?phone=5548991032835';
    },

    getUser() {
      return this.$auth.user;
    },

    isLoggedIn() {
      return this.$auth.isAuthenticated();
    },

    getCustomer() {
      const user = this.getUser();
      if (user) {
        return api.getCustomer(user.sub).then((data) => {
          this.customer = data;
        });
      }
      return {};
    },

    showRefreshUI(e) {
      this.registration = e.detail;
      this.updateExists = true;
    },

    refreshApp() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage('skipWaiting');
    },
  },
};
</script>

<style scoped>
.toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.positionActions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.positionActionsColumns {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.v-menu__content--fixed {
  top: 58px !important;
  left: 0px !important;
  min-width: 100% !important;
  border-bottom: 2px solid #e0e0e0;
}
.v-menu__content {
  box-shadow: none !important;
}
.v-toolbar__content .v-btn--icon,
.v-toolbar__extension .v-btn--icon {
  margin: 0px !important;
}
::v-deep .v-toolbar__extension {
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.v-toolbar__content {
  display: flex;
  flex-direction: column;
  height: 60px !important;
}

.button-background {
  color: white !important;
}
</style>

<style>
.borda-header {
  border: 1px solid red;
}

.v-chip__close {
  margin: 0px 0px 0px 10px;
}
.v-badge__badge {
  height: 15px;
  width: 15px;
  font-size: 10px;
}
.v-list__tile__action {
  min-width: 40px;
}

.v-toolbar__content {
  padding: 0;
}

.div.v-toolbar__extension {
  padding-left: 5px;
}
.profile-txt {
  font-family: 'Nunito sans';
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 10px;
  font-weight: normal;
}
</style>
